import { TextareaField } from "@/components";
import { CampaignForm } from "@/partial/campaign/types";
import { Control, UseFormSetValue, UseFormWatch } from "react-hook-form";
import { Accordion, Card } from "tvs-unified-lib";
import { LayoutRight } from "../../styles";
import { CampaignChannelForm } from "./components/campaign-channel-form";
import FilterAccountsForm from "./components/filter-accounts-form";

interface RightLayoutFormProps {
  isEdit: boolean;
  control: Control<CampaignForm>;
  setValue: UseFormSetValue<CampaignForm>;
  watch: UseFormWatch<CampaignForm>;
}

export const RightLayoutForm = ({
  isEdit,
  control,
  setValue,
  watch,
}: RightLayoutFormProps) => {
  const checkAIDC = watch("data_source") && watch("data_source")[0]?.value;

  return (
    <LayoutRight>
      {/* if checkAIDC is true, show Filter Accounts */}
      {checkAIDC === "AIDC" && (
        <Accordion
          defaultOpen
          header="Filter Accounts"
          className="card-channel"
        >
          <FilterAccountsForm
            control={control}
            setValue={setValue}
            isEdit={isEdit}
          />
        </Accordion>
      )}

      {/* Default Campaign Channel */}
      <Accordion defaultOpen header="Campaign Channel" className="card-channel">
        <CampaignChannelForm
          isEdit={isEdit}
          control={control}
          setValue={setValue}
          watch={watch}
        />
      </Accordion>

      <Card heading="Remarks">
        <TextareaField
          name="remarks"
          label="Remarks"
          control={control}
          placeholder="Enter Remarks Here"
          characterLimit={1000}
        />
      </Card>
    </LayoutRight>
  );
};

export default RightLayoutForm;
